var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({staticClass:"default-input",class:_vm.input_classes,attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.inputPhone}},'input',_vm.bind_data,false))
}
var staticRenderFns = []

export { render, staticRenderFns }